import React from 'react';
import { Box, Typography, Stack, Button, CircularProgress } from '@mui/material';
import { OpenInNew, Download as DownloadIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { DOCUMENT_VIEW_DIALOG_STYLES, UPLOAD_DIALOG_COLORS } from '../../../../../common/styles/dialogStyles';

interface DocumentActionsProps {
  canDelete: boolean;
  isDownloading: boolean;
  isViewing: boolean;
  isDeleting: boolean;
  onView: () => void;
  onDownload: () => void;
  onDelete: () => void;
}

export const DocumentActions: React.FC<DocumentActionsProps> = ({
  canDelete,
  isDownloading,
  isViewing,
  isDeleting,
  onView,
  onDownload,
  onDelete,
}) => (
  <Box sx={DOCUMENT_VIEW_DIALOG_STYLES.card}>
    <Typography
      variant="subtitle2"
      sx={{ fontWeight: 600, mb: 2, color: UPLOAD_DIALOG_COLORS.textPrimary }}
    >
      Available Actions
    </Typography>
    <Stack direction="row" spacing={2} flexWrap="wrap">
      <Button
        variant="contained"
        startIcon={isViewing ? <CircularProgress size={16} color="inherit" /> : <OpenInNew />}
        onClick={onView}
        disabled={isViewing || isDownloading || isDeleting}
        sx={DOCUMENT_VIEW_DIALOG_STYLES.viewButton}
      >
        {isViewing ? 'Loading...' : 'View Document'}
      </Button>
      <Button
        variant="outlined"
        startIcon={isDownloading ? <CircularProgress size={16} color="inherit" /> : <DownloadIcon />}
        onClick={onDownload}
        disabled={isDownloading || isViewing || isDeleting}
        sx={DOCUMENT_VIEW_DIALOG_STYLES.downloadButton}
      >
        {isDownloading ? 'Downloading...' : 'Download'}
      </Button>
      {canDelete && (
        <Button
          variant="outlined"
          startIcon={isDeleting ? <CircularProgress size={16} color="inherit" /> : <DeleteIcon />}
          onClick={onDelete}
          disabled={isDeleting || isViewing || isDownloading}
          sx={DOCUMENT_VIEW_DIALOG_STYLES.deleteButton}
        >
          {isDeleting ? 'Deleting...' : 'Delete'}
        </Button>
      )}
    </Stack>
  </Box>
);

export default DocumentActions;
